const ad = state => state.ad
const ads = state => state.ads

export default {
  ad,
  ads

}
